// src/components/PropertyPanel/CommonProperties/StyleControl.js
import React from 'react';
import { usePropertyPanel } from '../PropertyPanelContext';
import { useSelector } from 'react-redux';
import { selectSelectedComponent } from '../../../redux/editorSlice';

const StyleControl = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const { handleStyleChange } = usePropertyPanel();
  const style = selectedComponent?.style || {};
  
  // 박스 섀도우 설정
  const handleBoxShadowChange = (isChecked) => {
    if (!selectedComponent) return;
    
    if (isChecked) {
      handleStyleChange(selectedComponent, 'boxShadow', '0 4px 6px rgba(0, 0, 0, 0.1)');
    } else {
      handleStyleChange(selectedComponent, 'boxShadow', 'none');
    }
  };
  
  return (
    <div className="property-group">
      <div className="property-group-title">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 17L9 11L13 15L21 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M17 7H21V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        스타일 설정
      </div>
      <div className="property-controls">
        <div className="property-control">
          <label>배경색</label>
          <div className="color-picker-container">
            <input 
              type="color" 
              value={style?.backgroundColor || '#ffffff'} 
              onChange={(e) => handleStyleChange(selectedComponent, 'backgroundColor', e.target.value)}
            />
          </div>
        </div>
        <div className="property-control">
          <label>테두리 색상</label>
          <div className="color-picker-container">
            <input 
              type="color" 
              value={style?.borderColor || '#cccccc'} 
              onChange={(e) => handleStyleChange(selectedComponent, 'borderColor', e.target.value)}
            />
          </div>
        </div>
        <div className="property-control">
          <label>테두리 두께</label>
          <input 
            type="number" 
            min="0" 
            max="10" 
            value={parseInt(style?.borderWidth) || 0} 
            onChange={(e) => handleStyleChange(selectedComponent, 'borderWidth', `${e.target.value}px`)}
          />
        </div>
        <div className="property-control">
          <label>그림자 효과</label>
          <input 
            type="checkbox"
            checked={style?.boxShadow && style.boxShadow !== 'none'} 
            onChange={(e) => handleBoxShadowChange(e.target.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default StyleControl;